<template>
  <div class="contractors-modal-general-table">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'ContractorsModalGeneralTable',
  };
</script>
